import ColorItem from '../ColorItem';
import MediaItem from '../MediaItem';
import { BannerCarouselItemProps } from './types';

const BannerCarouselItem = ({
  bannerItem: {
    redirectUrl,
    title,
    media: { image, icon, color },
  },
}: BannerCarouselItemProps) => {
  if (color) {
    return <ColorItem colorName={color} />;
  }
  return <MediaItem redirectUrl={redirectUrl} image={image} icon={icon} title={title} />;
};

export default BannerCarouselItem;
